<template>
  <div class="slot-machine">
    <div class="slots" v-if="!isWin"
         :style="{backgroundImage:'url('+require('../../assets/images/slots/popback.png')+')'}">
      <div class="reels">
        <div class="reel" v-for="(reel, index) in reels" :key="index">
          <div class="icon">
            <img :src="reel.icons[reel.position]" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <div class="win" v-else
         :style="{backgroundImage:'url('+require('../../assets/images/slots/popback2.png')+')'}">
      <div class="getAll">
        <div class="getMoney">
          <div class="shadow">{{ $t('lang.account.currencyType') + fixFormat($store.state.hostGet) }}</div>
          <div class="gradient">{{ $t('lang.account.currencyType') + fixFormat($store.state.hostGet) }}</div>
        </div>
        <div class="getRate">
          <div class="shadow">{{ $store.state.hostRate }}</div>
          <div class="gradient">{{ $store.state.hostRate }}</div>
        </div>
      </div>
    </div>
    <div class="btn" @click="spin" v-if="!isWin"
         :style="{backgroundImage:'url('+require('../../assets/images/slots/btn.png')+')'}">
      <div class="text">Free Spin</div>
    </div>
    <div class="btn" style="margin-top: 5.127vw" @click="claim" v-else
         :style="{backgroundImage:'url('+require('../../assets/images/slots/btn.png')+')'}">
      <div class="text">Claim</div>
    </div>
    <div class="close" @click="handleClose"><img :src="close"/></div>
  </div>
</template>

<script>
import element1 from '@/assets/images/slots/element1.png'
import element2 from '@/assets/images/slots/element2.png'
import element3 from '@/assets/images/slots/element3.png'
import element4 from '@/assets/images/slots/element4.png'
import element5 from '@/assets/images/slots/element5.png'
import element6 from '@/assets/images/slots/element6.png'
import close from '@/assets/images/slots/close.svg'
import btn from '@/assets/images/slots/btn.png'

export default {
  name: 'SlotMachine',
  props: ['handleClose'],
  data () {
    return {
      btn,
      close,
      counts: [0, 0, 0],
      isPlaying: false,
      follow: 3,
      randomInterval: [null, null, null],
      isWin: false,
      reels: [
        {icons: [element1, element2, element3, element4, element5, element6], position: 0},
        {icons: [element1, element2, element3, element4, element5, element6], position: 0},
        {icons: [element1, element2, element3, element4, element5, element6], position: 0}
      ]
    }
  },
  mounted () {
    this.follow = Math.floor(Math.random() * this.reels[0].icons.length)
  },
  methods: {
    fixFormat (str) {
      return str + '.00'
    },
    spin () {
      if (!this.isPlaying) {
        this.isPlaying = true
        setTimeout(() => {
          this.isWin = true
        }, 2350)
        this.playingSlots(0, 30)
        setTimeout(() => {
          this.playingSlots(1, 30)
          setTimeout(() => {
            this.playingSlots(2, 25)
          }, 500)
        }, 500)
      }
    },
    claim () {
      this.handleClose()
      setTimeout(() => {
        this.$store.commit('setLoginPopShow', true)
        // this.$router.push('/Login')
      }, 50)
    },
    playingSlots (idx, speed) {
      this.randomInterval[idx] = setInterval(() => {
        this.doRandom(idx)
      }, speed)
    },
    doRandom (idx) {
      this.counts[idx]++
      const reel = this.reels[idx]
      if (this.counts[idx] < 25) {
        const x = Math.floor(Math.random() * reel.icons.length)
        reel.position = x
        if (this.counts[idx] % 3 === 0) {
          let icons = document.getElementsByClassName('icon')
          icons[idx].style.top = '-3vw'
        } else if (this.counts[idx] % 3 === 1) {
          let icons = document.getElementsByClassName('icon')
          icons[idx].style.top = '0'
        } else if (this.counts[idx] % 3 === 2) {
          let icons = document.getElementsByClassName('icon')
          icons[idx].style.top = '3vw'
        }
      } else if (this.counts[idx] === 25) {
        // 生成随机位置
        let icons = document.getElementsByClassName('icon')
        icons[idx].style.top = '0'
        reel.position = this.follow
        clearInterval(this.randomInterval[idx])
        this.counts[idx] = 0
      }
    }
  }
}
</script>

<style scoped>
.slot-machine {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  overflow: hidden;

  .close {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    top: 32vw;
    width: 4.722vw;
    height: 4.722vw;

    img {
      width: 4.722vw;
      height: 4.722vw;
    }
  }

  .btn {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    top: 26vw;
    width: 60vw;
    height: 12.777vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;

    .text {
      position: relative;
      font-weight: 700;
      text-align: center;
      color: #FFFFFF;
      font-size: 5.833vw;
      line-height: 12.777vw;
      text-shadow: 1px 1px 0 #386A03,
      -1px 1px 0 #386A03,
      1px -1px 0 #386A03,
      -1px -1px 0 #386A03,
      0 1px 0 #386A03,
      0 -1px 0 #386A03,
      -1px 0 0 #386A03,
      1px 0 0 #386A03,
      0 2px 2px rgba(0, 0, 0, 0.5);
      z-index: 1;
    }
  }
  .slots {
    position: relative;
    top: 30vw;
    left: 50%;
    transform: translate(-50%);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    width: 112.222vw;
    height: 102.63vw;

    .reels {
      position: absolute;
      top: 65vw;
      left: 31vw;
      width: 46vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      .reel {
        position: relative;
        width: 12.5vw;
        height: 17vw;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .icon {
        position: relative;
        width: 12.5vw;
        height: 16.111vw;
        display: flex;
        align-items: center;
        img{
          width: 12.5vw;
        }
      }
    }
  }
  .win {
    position: relative;
    top: 28vw;
    left: 50%;
    transform: translate(-50%);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    width: 107.289vw;
    height: 97.5vw;

    .getAll {
      position: absolute;
      top: 77vw;
      left: 23vw;
      width: 59vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;

      .getMoney {
        position: relative;
        text-align: center;
        width: max-content;
      }
      .getRate {
        position: relative;
        width: max-content;
        text-align: center;
      }
      .gradient{
        position: relative;
        height: 6.38vw;
        background-image: linear-gradient(180deg, #FFFFFF 0%, #FFC700 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-size: 5.555vw;
        font-weight: 700;
      }
      .shadow{
        position: absolute;
        top: 0;
        width: 100%;
        text-align: center;
        font-size: 5.555vw;
        font-weight: 700;
        color: rgba(255, 255, 255, 0);
        text-shadow: 1px 1px 0 #5F0600,
        -1px 1px 0 #5F0600,
        1px -1px 0 #5F0600,
        -1px -1px 0 #5F0600,
        0 1px 0 #5F0600,
        0 -1px 0 #5F0600,
        -1px 0 0 #5F0600,
        1px 0 0 #5F0600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SlotMachine/index.vue